import { render } from "./LogoUpload.vue?vue&type=template&id=c2f8292a"
import script from "./LogoUpload.vue?vue&type=script&lang=js"
export * from "./LogoUpload.vue?vue&type=script&lang=js"

import "./LogoUpload.vue?vue&type=style&index=0&id=c2f8292a&lang=css"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__